import {HideHook, Page} from "@/PageDescriptors";
import {domainPermissionHideHook, EndpointBreadcrumb} from "./tools";

import FaxList from "@/components/fax/FaxList";
import FaxSettingsPage from "@/components/fax/settings/FaxSettingsPage";
import {FaxRecordsPage} from "@/components/fax/records/FaxRecordsPage";
import DeleteFaxPage from "@/components/fax/delete/DeleteFaxPage";
import {useStructureConfig} from "@/context/StructureConfigProvider";
import {defineMessage} from "react-intl";

function useServiceHideHook(): boolean {
    const config = useStructureConfig();
    return !config.isEnabledService("fax");
}

function serviceAndPermissionHideHook(): HideHook {
    return (auth) => {
        const serviceHook = useServiceHideHook();
        const permissionHook = domainPermissionHideHook("delete_fax")(auth);
        return serviceHook || permissionHook;
    };
}

const faxesPage: Page = {
    path: "faxes",
    label: defineMessage({id: "faxes", defaultMessage: "Faxes"}),
    contentComponent: FaxList,
    hideHook: useServiceHideHook,
    items: [
        {
            path: ":faxId",
            label: null,
            breadcrumbComponent: EndpointBreadcrumb("faxes", "faxId"),
            items: [
                {
                    path: "settings",
                    label: defineMessage({id: "settings", defaultMessage: "Settings"}),
                    contentComponent: (props: {[s: string]: any}) => (
                        <FaxSettingsPage domainId={props.domainId} faxId={props.faxId} />
                    ),
                },

                {
                    path: "records",
                    label: defineMessage({id: "faxRecords", defaultMessage: "Fax records"}),
                    contentComponent: (props: {[s: string]: any}) => <FaxRecordsPage faxId={props.faxId} />,
                },

                {
                    path: "delete",
                    label: defineMessage({id: "delete", defaultMessage: "Delete"}),
                    hideHook: serviceAndPermissionHideHook(),
                    contentComponent: (props: {[s: string]: any}) => (
                        <DeleteFaxPage domainId={props.domainId} faxId={props.faxId} />
                    ),
                },
            ],
        },
    ],
};

export default faxesPage;
